<template>
  <div class="flex items-center">
    <input
      :id="name + formId"
      v-model="checked"
      :name="name"
      type="checkbox"
      :hidden="hidden"
      :disabled="disabled"
      :read-only="readOnly"
      :required="required"
      class="mr-2 h-7 w-7 appearance-none rounded outline-0 checked:bg-blue hover:checked:bg-blue-dark focus:ring-0 focus:checked:bg-blue lg:h-8 lg:w-8"
    />
    <label :for="name + formId" class="text-l5 block text-base leading-normal lg:text-lg">
      {{ label }}
    </label>
  </div>
</template>

<script setup lang="ts">
import { useVModel } from '@vueuse/core'
const props = defineProps({
  label: String,
  modelValue: { type: Boolean },
  name: { type: String, default: '' },
  required: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  hidden: { type: Boolean, default: false },
  readOnly: { type: Boolean, default: false },
  formId: { type: String, default: '' },
})
const emit = defineEmits(['update:modelValue'])

const checked = useVModel(props, 'modelValue', emit)
</script>
